import * as React from 'react';
import { withStyles, Theme, WithStyles, createStyles } from '@material-ui/core';
import Tab, { TabProps } from 'ha/ui/next/Tab';
import units from 'ha/theme/units';

export const styles = (t: Theme) =>
  createStyles({
    root: {
      zIndex: 1,
    },
    labelContainer: {
      margin: units.rem(0.25),
      padding: units.yx(0.5, 1),
    },
  });

interface StyledTabProps {
  selectedClassName?: string;
}

type Props = StyledTabProps & TabProps & WithStyles<typeof styles>;

export const StyledTab: React.SFC<Props> = ({
  selectedClassName,
  classes,
  ...otherProps
}) => (
  <Tab
    disableRipple
    classes={{
      selected: selectedClassName,
      ...classes,
    }}
    {...otherProps}
  />
);

export default withStyles(styles)(StyledTab);
